import { render } from "./BaseDialogue.vue?vue&type=template&id=1114dc4e&scoped=true"
import script from "./BaseDialogue.vue?vue&type=script&lang=js"
export * from "./BaseDialogue.vue?vue&type=script&lang=js"

import "./BaseDialogue.vue?vue&type=style&index=0&id=1114dc4e&scoped=true&lang=css"

import exportComponent from "/Users/josecisneros/Desktop/Jose-Cisneros/Portfolio-Site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1114dc4e"]])

export default __exports__